export default __webpack_public_path__ + "static/media/english-to-italian-screenshot-03.9de8efb3.png";